export var ArrowType;
(function (ArrowType) {
    ArrowType[ArrowType["Simple"] = 0] = "Simple";
    ArrowType[ArrowType["Polygon"] = 1] = "Polygon";
    ArrowType[ArrowType["Teleport"] = 2] = "Teleport";
})(ArrowType || (ArrowType = {}));
export var IndicatorType;
(function (IndicatorType) {
    IndicatorType[IndicatorType["PolygonalShape"] = 0] = "PolygonalShape";
    IndicatorType[IndicatorType["PolygonalWithIndicator"] = 1] = "PolygonalWithIndicator";
    IndicatorType[IndicatorType["IndicatorOnly"] = 2] = "IndicatorOnly";
    IndicatorType[IndicatorType["Invisible"] = 3] = "Invisible";
})(IndicatorType || (IndicatorType = {}));
